<template>
    <section class="detail" v-loading="loading">

        <div class="title">
            <img :src="icon" width="30"/>
            <p>
                <label>{{detail.descripcion}}</label>
                <span>{{detail.ubicacion}}</span>
            </p>
            <i v-if="showClose"
                class="el-icon-close"
                @click="$emit('close')"></i>
        </div>

        <el-tabs v-model="tab" >

            <!-- Visor -->
            <el-tab-pane label="VISOR" name="Visor" v-if="visor">

                <Preview
                :currentObject="detail"
                :embedVisor="true"/>

            </el-tab-pane>

            <!-- Actions -->
            <el-tab-pane label="ACCIONES" name="Acciones">

                <div class="block">
                    <el-button
                        style="width: 100%; margin-bottom: 5px"
                        icon="el-icon-delete"
                        @click.stop.prevent="confirmDeleteFile()">
                        Eliminar archivo
                    </el-button>
                </div>

                <div class="block">
                    <el-button
                        style="width: 100%; margin-bottom: 5px"
                        icon="el-icon-paperclip"
                        @click.stop.prevent="dialogShare = true">
                        Compartir enlace
                    </el-button>
                </div>

                <div class="block">
                    <el-button
                        style="width: 100%; margin-bottom: 5px"
                        icon="el-icon-share"
                        v-if="window && window.navigator.share"
                        @click="shareApi()">
                        Compartir archivo
                    </el-button>
                </div>

                <div class="block" style="margin-top: 25px; margin-bottom: 5px">
                    <el-button
                        type="primary"
                        plain
                        style="width: 100%"
                        @click="firmar()">
                        Firmar documento
                    </el-button>
                </div>

                <div class="block" style="margin-bottom: 5px">
                    <el-button
                        type="primary"
                        plain
                        style="width: 100%">
                        Convertir a PDF
                    </el-button>
                </div>

                <template v-if="showAccionesEleccion()">
                    <div class="block" style="margin-bottom: 5px">
                        <el-button
                            style="width: 100%"
                            type="success"
                            plain
                            @click="workflowAction('afirmativo')">
                            Aprobar
                        </el-button>
                    </div>
                    <div class="block">
                        <el-button
                            style="width: 100%"
                            type="danger"
                            plain
                            @click="workflowAction('negativo')">
                            Rechazar
                        </el-button>
                    </div>
                </template>

            </el-tab-pane>

            <!-- Propiedades -->
            <el-tab-pane label="PROPIEDADES" name="Propiedades" class="panel-propiedades">

                <Propiedades
                    :id="detail.id"
                    :detail="detail"
                    :showDescription="false"
                    :esquema="detail.esquema"
                    @loading="val => loading = val"
                    @save="$emit('savePropiedades')"/>
                
            </el-tab-pane>

            <!-- Informacion -->
            <el-tab-pane label="INFORMACION" name="Información">

                <div class="informacion-container">

                    <div class="informacion-content">

                        <!-- INFORMACION -->
                        <template v-if="infotab === 'info'">
                            <ul class="properties" style="margin-bottom: 25px;">
                                <li>
                                    <label>Esquema</label>
                                    <p>{{detail.esquema.descripcion.replace(/_|#|-|@|<>/g, ' ')}}</p>
                                </li>
                                <li>
                                    <label>Tipo</label>
                                    <p>{{detail.tipo == 'D' ? 'Documento' : 'Fichero'}}</p>
                                </li>
                                <li>
                                    <label>Tamaño</label>
                                    <p>{{detail.size}} Kb</p>
                                </li>
                                <li>
                                    <label>Tipo de fichero</label>
                                    <p>{{detail.descripcion.split('.')[detail.descripcion.split('.').length - 1].toUpperCase()}}</p>
                                </li>
                                <li>
                                    <label>Ubicación</label>
                                    <p>{{detail.ubicacion}}</p>
                                </li>
                                <li>
                                    <label>Modificación</label>
                                    <p>{{detail.modificacion}}</p>
                                </li>
                                <li>
                                    <label>Creado el</label>
                                    <p>{{detail.fecha}}</p>
                                </li>
                                <li>
                                    <label>Descripción</label>
                                    <p>{{detail.descripcion}}</p>
                                </li>
                            </ul>

                            <!--<el-button
                                type="text"
                                icon="el-icon-delete"
                                @click.stop.prevent="confirmDeleteFile()"
                            >Eliminar archivo</el-button>-->

                            <!--<el-button
                                type="text"
                                icon="el-icon-paperclip"
                                style="margin-left: 25px"
                                @click.stop.prevent="dialogShare = true"
                            >Compartir enlace</el-button>-->

                            <!--<el-button
                                type="text"
                                icon="el-icon-share"
                                style="margin-left: 25px"
                                v-if="window && window.navigator.share"
                                @click.stop.prevent="shareApi()">
                                Compartir
                                </el-button>-->

                            <span class="title-etiqueta">Notas</span>
                            <el-form label-position="top" style="margin-bottom: 20px">
                                <el-input type="textarea" :rows="2" v-model="notas" @blur="updateNotas" placeholder="Escribe aquí las notas del documento"></el-input>
                            </el-form>

                            <span class="title-etiqueta">

                                <!-- Añadir etiqueta -->
                                <el-input
                                    class="input-new-tag"
                                    v-if="etiquetaInputVisible"
                                    v-model="etiquetaInputValue"
                                    ref="saveTagInput"
                                    size="mini"
                                    @keyup.enter.native="etiquetaHandleInputConfirm"
                                    @blur="etiquetaHandleInputConfirm"/>
                                <el-button
                                    v-else
                                    class="button-new-tag"
                                    size="mini"
                                    @click="etiquetaShowInput"
                                    icon="el-icon-plus">
                                    Etiqueta
                                </el-button>
                            </span>
                            <el-tag
                                v-for="tag in etiquetas"
                                :key="tag"
                                closable
                                :disable-transitions="true"
                                @close="removeEtiqueta(tag)"
                                size="small">{{tag}}</el-tag>
                            
                        </template>

                        <!-- VERSIONES -->
                        <template v-if="infotab === 'versiones'">
                            <el-timeline v-if="detail.versiones && detail.versiones.length">
                                <el-timeline-item
                                v-for="(version, v) in detail.versiones"
                                :key="v"
                                :timestamp="version.modificacion">
                                    <b>versión {{version.version}}</b> por {{version.creador}}
                                    <el-button
                                        style="margin-left: 5px"
                                        @click="downloadVersion(version)"
                                        size="mini"
                                        circle
                                        type="primary"
                                        icon="el-icon-download"
                                        plain/>
                                </el-timeline-item>
                            </el-timeline>
                            
                            <div v-else class="empty-simple">
                                <img :src="require(`@/assets/noresults.svg`)">
                                <p>No hemos encontrado versiones</p>
                            </div>
                        </template>

                        <!-- ACTIVIDAD -->
                        <template v-if="infotab === 'actividad'">
                            <el-timeline v-if="detail.actividad && detail.actividad.length">
                                <el-timeline-item
                                v-for="(actividad, a) in detail.actividad"
                                :key="a"
                                :timestamp="actividad.fecha">
                                <b>{{actividad.accion}}</b> por {{actividad.usuario}}
                                </el-timeline-item>
                            </el-timeline>
                            <!--<ul class="properties" v-if="detail.actividad && detail.actividad.length">
                                <li v-for="(actividad, a) in detail.actividad" :key="a">
                                    <label>{{actividad.accion}}</label>
                                    <div>
                                        <p>{{actividad.usuario}}</p><span>sdfsdf</span></div>
                                </li>
                            </ul>-->
                            <div v-else class="empty-simple">
                                <img :src="require(`@/assets/noresults.svg`)">
                                <p>No hemos encontrado versiones</p>
                            </div>
                        </template>

                    </div>

                    <div class="informacion-tabs">
                        <ul>
                            <li :class="[{active: infotab === 'info'}]" @click="infotab = 'info'">Información</li>
                            <li :class="[{active: infotab === 'versiones'}]" @click="infotab = 'versiones'">Versiones</li>
                            <li :class="[{active: infotab === 'actividad'}]" @click="infotab = 'actividad'">Actividad</li>
                        </ul>
                    </div>
                    
                </div>

            </el-tab-pane>
        </el-tabs>

        <!-- Modal compartir enlace -->
        <el-dialog
            title="Compartir enlace"
            :visible.sync="dialogShare"
            :append-to-body="true"
            class="dialog-share">

            <el-input id="enlace_descarga" :value="detail.enlace_descarga" class="input-with-select" :read-only="true">
                <el-tooltip slot="append" class="item" effect="dark" content="Copiar al portapapeles" placement="top">
                    <el-button icon="el-icon-copy-document" @click="copyShareUrl()"></el-button>
                </el-tooltip>
            </el-input>

        </el-dialog>

    </section>
</template>

<script>
import {
    editarNotaElemento,
    editarEtiquetaElemento,
    savePropiedades,
    descargarElemento,
    borrarElemento,
    getUrl,
    obtenerBinario,
    ejecutarEleccion
} from "../api/api.js";

import Preview from './Preview.vue'
import Propiedades from './Propiedades.vue'
import InputLlood from './inputs/InputLlood.vue'
import moment from 'moment'

export default {
  name: 'Detail',
  components: {
    Preview,
    InputLlood,
    Propiedades
  },
  props: {
    detail: {
        type: Object
    },
    visor: {
        type: Boolean,
        default: true
    },
    showClose: {
        type: Boolean,
        default: true
    },
    esquemas: {
        type: Array
    },
    filterSearch: {
        type: Array
    },
    icon: {
        type: String
    }
  },
  data() {
      return {
        window,
        tab: 'Visor',
        infotab: 'info',
        activeName: '1',

        // NOTAS
        notas: '',

        // ETIQUETAS
        etiquetaInputVisible: false,
        etiquetaInputValue: '',
        etiquetas: [],

        loading: false,

        // Modal share
        dialogShare: false,

        // Mostrar acciones tras exito
        showActions: true,
      }
  },
    watch: {
        'detail.id' (){
            this.init()
        }
    },
  mounted() {
    this.init()
  },
  methods: {
    init() {
        this.showActions = true
        let detail = JSON.parse(JSON.stringify(this.detail))

        this.notas = detail.notas
        this.etiquetas = detail.etiquetas ? detail.etiquetas.split(';').filter(f => f != "") : []

        this.tab = this.visor ? 'Visor' : 'Propiedades'
    },

    // ELIMINAR ARCHIVO
    confirmDeleteFile() {

        this.$confirm('¿Desea borrar el archivo?', 'Eliminar', {
          confirmButtonText: 'Continuar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }).then(() => {
          this.deleteFile()
        })

    },
    async deleteFile() {

        this.loading = true

        try {

            let data = {
                elementos: [this.detail.id]
            }

            let resp = await borrarElemento(data)

            this.$notify.success({
                title: '!Bien!',
                message: 'Archivo borrado'
            })

            this.$emit('fileDeleted', this.detail)

        } catch (err) {

            this.$notify.error({
                title: '!Ups!',
                message: 'Ha ocurrido un error al borrar el archivo'
            })
        }

        this.loading = false
    },

    // EDITAR NOTAS
    async updateNotas(){

        if (this.detail.notas == this.notas) return

        this.loading = true

        try {

            let resp = await editarNotaElemento(this.detail.id, {notas: this.notas})

            this.detail.notas = this.notas

            this.$notify.success({
                title: '!Bien!',
                message: 'Notas actualizadas'
            })

        } catch (err) {

            this.$notify.error({
                title: '!Ups!',
                message: 'Ha ocurrido un error al guardar notas'
            })

            this.notas = JSON.parse(JSON.stringify(this.detail.notas))
        }

        this.loading = false
    },

    // EDITAR ETIQUETAS
    etiquetaShowInput() {
        this.etiquetaInputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
    },
    etiquetaHandleInputConfirm() {
        let etiquetaInputValue = this.etiquetaInputValue;

        if (
            etiquetaInputValue &&
            etiquetaInputValue !== null &&
            etiquetaInputValue !== ''
        ) {
            this.etiquetas.push(etiquetaInputValue)
        } else {
            this.etiquetaInputVisible = false;
            this.etiquetaInputValue = '';
            return
        }

        this.etiquetaInputVisible = false;
        this.etiquetaInputValue = '';

        this.updateEtiquetas()
    },
    async updateEtiquetas() {

        this.loading = true

        try {

            await editarEtiquetaElemento(this.detail.id, {etiquetas: this.etiquetas.join(';')})

            this.detail.etiquetas = this.etiquetas.join(';');

            this.$notify.success({
                title: '!Bien!',
                message: 'Etiquetas actualizadas'
            })

        } catch (err) {

            this.$notify.error({
                title: '!Ups!',
                message: 'Ha ocurrido un error al guardar etiquetas'
            })

            this.etiquetas = JSON.parse(JSON.stringify(this.detail.etiquetas || []))
        }

        this.loading = false
    },
    async removeEtiqueta(etiqueta) {

        let etiquetaIndex = this.etiquetas.indexOf(etiqueta)
        if (etiquetaIndex < 0) return

        this.etiquetas.splice(etiquetaIndex, 1)

        this.loading = true

        try {

            await editarEtiquetaElemento(this.detail.id, {etiquetas: this.etiquetas.join(';')})

            this.detail.etiquetas = this.etiquetas.join(';');

            this.$notify.success({
                title: '!Bien!',
                message: 'Etiqueta borrada'
            })

        } catch (err) {

            this.$notify.error({
                title: '!Ups!',
                message: 'Ha ocurrido un error al borrar la etiqueta'
            })

            this.etiquetas = JSON.parse(JSON.stringify(this.detail.etiquetas || []))
        }

        this.loading = false
    },

    // VERSIONES
    async downloadVersion(version) {

        this.loading = true

        try {

            const { data } = await descargarElemento(version.id)

            location.href = getUrl() + 'acceso/externo/?token=' + data.token + '&id=' + data.fichero

        } catch(e) {

            this.$notify.error({
                title: 'Error',
                message: 'Error al descargar la versión'
            });
        }

        this.loading = false

    },

    // COPIAR A PORTAPAPELES
    copyShareUrl() {

        var copyText = document.getElementById("enlace_descarga");

        copyText.select();
        copyText.setSelectionRange(0, 99999);

        document.execCommand("copy");

        this.$message({
          message: 'Enlace copiado al portapapeles.',
          type: 'success'
        });

        this.dialogShare = false
    },

    // COMPARTIR ARCHIVO
    async shareApi() {

        if (!window.navigator) return console.warm('Navegador antiguo, no puede compartir')

        let _self = this

        _self.loading = true

        let binario = null
        try {

            let resp = await obtenerBinario({
                id: _self.detail.id
            })
            //console.log('resp obtenerBinario: ',resp)
            binario = resp.data

        } catch(e) {
            //console.log('error binario: ', e)
        }

        _self.loading = false

        if (window.navigator.canShare()) {

            try {

                let obj = {
                    title: _self.detail.descripcion,
                    text: _self.detail.descripcion_elemento
                }

                if (binario) {
                    obj.files = [new File([binario], _self.detail.descripcion, {type: 'text/csv'})]
                } else {
                    obj.url = _self.detail.enlace_descarga
                }
                //console.log('share: ',obj)
                //console.log(navigator.canShare({files: obj.files}))
                await navigator.share(obj)

                console.log('Todo bien')

            }
            catch (err) { console.error(err) }

        }

        function blobToFile(theBlob, fileName){
            //A Blob() is almost a File() - it's just missing the two properties below which we will add
            theBlob.lastModifiedDate = new Date();
            theBlob.name = fileName;
            return theBlob;
        }
    },

    // FIRMAR
    firmar() {
        this.$notify.error({
            title: 'Error',
            message: 'No dispone de certificados digitales'
        })
    },

    // WORKFLOW
    async workflowAction(value) {

        this.loading = true

        try {

            let resp = await ejecutarEleccion({
                id: this.detail.id,
                eleccion: value
            })

            this.$notify.success({
                title: 'Bien',
                message: 'Elección ejecutada'
            })

            this.showActions = false;
            this.$emit('saveWorkflow')

        } catch (e) {

            this.$notify.error({
                title: 'Error',
                message: 'Elección no ejecutada'
            })

        }

        this.loading = false
    },

    showAccionesEleccion () {
        const esRecibida = this.detail.esquema.descripcion == 'facturas_recibidas'
        const esBorrador = this.detail.esquema.grupos.some(grupo => grupo.estructura.find(estructura => {
            const listaEstado = this.filterSearch.find(f => f.placeholder == 'estado');
            const listaId = listaEstado ? listaEstado.lista : null;
            return listaId == estructura.lista__id && estructura.valor == 'borrador'
        }))

        return esRecibida && esBorrador && this.showActions
    }
  }
}
</script>

<style lang="scss">
section.detail {
    position: absolute;
    z-index: 99;
    right: 0;
    height: 100%;
    background-color: white;
    max-width: calc(100% - 30px)!important;
    min-width: unset!important;
    border-left: 1px solid #dcdfe6;
    padding: 0px 15px;
    overflow: auto;
    display: flex;
    flex-flow: column;

    .title {
        display: flex;
        justify-content: space-between;
        padding: 15px 0px 35px 0px;
        i {
            font-size: 1.4rem;
            cursor: pointer;
            &:not(.el-icon-close) {
                display: none;
            }
        }
        p {
            margin: 0px;
            display: flex;
            flex-flow: column;
            flex-grow: 1;
            padding: 0px 20px;
            label {
                margin-bottom: 8px;
            }
            span {
                font-size: 0.75rem;
                color: #606266d1;
                text-transform: uppercase;
            }
        }
    }

    ul.properties {
        padding: 0px;
        margin: 0px 0px 10px 0px;
        border: 1px solid #dcdfe6;
        border-radius: 3px;
        line-height: 2;
        li {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #eaecf0;
            font-size: 0.85rem;
            label {
                flex-grow: 1;
                min-width: 150px;
                max-width: 150px;
                background-color: #fafafa;
                padding: 6px 9px;
                border-right: 1px solid #dcdfe6;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                flex-shrink: 0;
                text-transform: uppercase;
                font-weight: 500;
                font-size: 0.71rem;
            }
            form.input-llood {
                flex-grow: 1;
                input {
                    height: auto;
				    border-radius: 0px;
				    border: 1px solid #d63031;
                }
                &:not(.readonly) {
                    .label {
                        color: #d63031;
                    }
                }
            }
            // descripcion_elemento
            .el-form-item.editable textarea {
                color: #d63031;
            }
            p {
                margin: 0px;
                flex-grow: 1;
                padding: 4px 9px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            &:last-child {
                border: 0px;
            }
        }
    }

    /* Tabs */
    .el-tabs.el-tabs--top {
        height: 100%;
        min-height: 0;
        display: flex;
        flex-flow: column;

        .el-tabs__content {
            overflow: auto;
            overflow-x: hidden;
            position: relative;
            min-height: 0;
            flex-grow: 1;
            margin-bottom: 15px;

            div#pane-Visor {
                height: 100%;
                #preview {
                    background-color: #fafafa;
		            border: 1px solid #dcdfe6;
                }
            }
            div#pane-Propiedades {
                overflow: hidden;
                height: 100%;
                .propiedades-container {
                    height: 100%;
                    .propiedades-content {
                        height: calc(100% - 51px);
                        overflow: auto;
                    }
                }
            }
            div#pane-Información {
                overflow: hidden;
                height: 100%;
                .informacion-container {
                    height: 100%;
                    .informacion-content {
                        height: calc(100% - 51px);
                        overflow: auto;
                    }
                    .informacion-tabs {
                        ul {
                            padding: 0px;
                            list-style: none;
                            display: flex;
                            align-items: center;
                            margin: 0px;
                            border-top: 2px solid #e4e7ed;
                            li {
                                cursor: pointer;
                                border-top: 2px solid transparent;
                                padding: 15px 0px;
                                top: -2px;
                                position: relative;
                                font-size: 14px;
                                margin: 0px 18px;
                                &:first-child {
                                    margin-left: 0px;
                                }
                                &.active {
                                    border-top: 2px solid #d63031;
                                    color: #d63031;
                                }
                                &:hover {
                                    color: #d63031;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    /* Timeline */
    .el-timeline {
        padding-top: 3px;
    }

    /* Editar etiquetas */
    span.title-etiqueta {
        font-size: 0.9rem;
        margin-right: 10px;
        height: 24px;
        display: inline-block;
    }
    .el-tag {
        margin-right: 5px;
        margin-bottom: 5px;
    }
    .input-new-tag {
        width: 150px;
        vertical-align: bottom;
    }

    @media (min-width: 650px) {
        max-width: 600px!important;
    }

    @media (min-width: 768px) {
        min-width: 500px!important;
        max-width: 500px!important;
        .title > i:not(.el-icon-close) {
            display: block;
        }
    }

    @media (min-width: 1120px) {
        display: flex;
        position: relative;
        min-width: 500px!important;
        max-width: 500px!important;
    }

    .empty-simple {
        display: flex;
        align-items: center;
        flex-flow: column;
        margin-top: 100px;
        img {
            width: 150px;
        }
        p {
            color: #a2a2a2;
        }
    }

    // Modal compartir enlace
    .dialog-share .el-dialog {
        width: 95%!important;
    }
    @media (min-width: 768px) {
        .dialog-share .el-dialog {
            width: 500px!important;
        }
    }
    
}
</style>
